import { resolveTokens } from "./tokens";
import { brandKey } from "../../brand";

// Each brand renders its own token set; GPS Care keeps the pre-TLS-14 values.
const tokens = resolveTokens(brandKey);

export const eventsPickableColors = [
    "#043c54",
    "#3b7691",
    "#00b1ff",
    "#b600ff",
    "#440062",
    "#ff9400",
    "#ff0090",
]

export function color(val) {
    return tokens.colors[`${val}`] ?? val;
}

export function radius(val) {
    return tokens.radius[`${val}`] ?? val;
}

export function shadow(val) {
    return tokens.shadow[`${val}`] ?? val;
}

export function fontFamily() {
    return tokens.font.family;
}

export function textSize(val) {
    return tokens.type[`${val}`] ?? tokens.type.default;
}

const space = {
    0: "0px",
    1: "4px",
    2: "8px",
    3: "12px",
    4: "16px",
    5: "24px",
    6: "32px",
    7: "48px",
    8: "64px",
    9: "128px",
    10: "164px",
    auto: "auto",
};

export function spacing(val) {
    return space[`${val}`] || val;
}

export const breakpoints = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
};

export const sizes = {
    maxPage: 1100,
    maxPageSm: 960,
    maxPageXs: 600,
};

const ratingEmojis = {
    1: "🙁",
    3: "😊",
    5: "🤩",
}

export const ratingEmoji = (rating) => {
    return ratingEmojis[rating]
}